import { createAction } from "@ngrx/store";
import { IExam } from "../../models/exam/exam.model";

export const loadExams = createAction(
  '[Exam] Load Exams',
  (exams: IExam[]) => ({exams})
);
